import React, { useCallback } from 'react'
import classNames from 'classnames'
import { IProposal } from '@/types'

import { useData } from '../useData'
import ProposalForm from './form'

interface IEditDeal {
  visible: boolean
  onClose: () => void
  node?: Partial<IProposal>
}

const EditProposal: React.FC<IEditDeal> = ({ visible, onClose, node }) => {
  const { loading, submitting, onSubmit } = useData({ id: node?.id })

  const onSubmitForm = useCallback(
    (d: IProposal) => {
      // @ts-ignore
      onSubmit(`deals/proposal/${node?.id}/`, true, onClose)(d)
    },
    [node?.id, onClose, onSubmit],
  )

  return (
    <div
      className={classNames('info-box mobile-modal scroll-sticky w-100', {
        open: visible,
      })}
    >
      <ProposalForm
        loading={loading}
        isEditing={visible}
        initialData={node}
        onCancel={onClose}
        submitting={submitting}
        onSubmit={onSubmitForm}
      />
    </div>
  )
}

export default EditProposal
